'use client'

import Link from 'next/link'
import { HugeiconsIcon } from '@hugeicons/react'
import {
  Invoice01Icon,
  ArrowRight01Icon,
} from '@hugeicons-pro/core-stroke-rounded'

const STATEMENTS_TILE = 'linear-gradient(135deg, #0A8A6E, #2BC39A)'

export function StatementsCard() {
  return (
    <Link
      href="/wallet/statements"
      className="bv3-brow clickable no-underline"
      style={{ marginTop: 8 }}
    >
      <div className="ic" style={{ background: STATEMENTS_TILE }}>
        <HugeiconsIcon icon={Invoice01Icon} className="size-5" />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 700 }}>Statements</div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>
          Monthly receipts for AI event credit consumption.
        </div>
      </div>
      <HugeiconsIcon
        icon={ArrowRight01Icon}
        className="size-[18px]"
        style={{ color: '#aaa' }}
      />
    </Link>
  )
}
